import { CrlAvatarColorKey } from '../../models';

/**
 * The eight pastel palette keys used for initial-avatars across the CRL surface
 * (activity feed + overlay details rail). Each key has a matching
 * `.<prefix>--<key>` rule emitted by the `avatar-pastel-colors` SCSS mixin.
 */
export const AVATAR_COLOR_KEYS: readonly CrlAvatarColorKey[] = [
  'teal',
  'blue',
  'purple',
  'amber',
  'rose',
  'green',
  'indigo',
  'slate',
];

/**
 * Deterministic pastel key for an avatar, hashed from a stable seed so the same
 * person always gets the same colour. Callers pass an id-derived seed where an
 * id is available (e.g. `#42`), falling back to name/email.
 */
export function pickAvatarColorKey(seed: string): CrlAvatarColorKey {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLOR_KEYS[hash % AVATAR_COLOR_KEYS.length];
}
